import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

export default function PaymentCancelPage() {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={3}
    >
      <Typography variant="h4" color="error">
        Payment Cancelled
      </Typography>
      <Typography variant="body1">
        Your payment was cancelled. No charges were made to your account.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/pricing')}>
        Return to Pricing
      </Button>
    </Box>
  );
}
